import { calculateSlotPositions } from "../Helpers/slotRenderer";

/**
 * Abstrakte Basis-Klasse für alle Kalender-Driver (Month, Quarter, Year, etc.)
 *
 * Jeder Driver muss implementieren:
 * - today() - Navigation zum aktuellen Zeitpunkt
 * - next() - Navigation zur nächsten Periode
 * - previous() - Navigation zur vorherigen Periode
 * - getDateRange() - Gibt {from, to} zurück
 * - switcherLabel() - Label für die UI (z.B. "Dezember 2024")
 */
export default class AbstractDriver {
  // Navigation
  today() {
    this._notImplemented("today");
  }

  next() {
    this._notImplemented("next");
  }

  previous() {
    this._notImplemented("previous");
  }

  // State - muss {from, to} moment Objects zurückgeben
  getDateRange() {
    this._notImplemented("getDateRange");
    return { from: null, to: null };
  }

  // Display
  switcherLabel() {
    this._notImplemented("switcherLabel");
    return "";
  }

  // Rendering - nutzt slotRenderer Utility
  // Diese Methode muss NICHT überschrieben werden
  renderSlot(slotData) {
    const { from, to } = this.getDateRange();
    return calculateSlotPositions(slotData, from, to);
  }

  _notImplemented(name) {
    console.warn(`${name}() muss in abgeleiteter Klasse implementiert werden`);
  }
}
